module.exports = __webpack_public_path__ + "img/seiheki-chan.db17a77b.jpg";